﻿'use strict';

/*jslint bitwise: true */
angular.module('ntmApp')
  .filter('HmsTimeFormat', function () {
      return function (input) {
          if (angular.isNumber(input)) {

              var allMinuteTime = parseFloat(input);

              var hours = Math.floor(allMinuteTime / 60);

              var minutes = Math.floor(allMinuteTime - hours * 60);

              var seconds = Math.round((allMinuteTime - ((hours * 60) + minutes)) * 60);

              if (minutes === 60) {hours += 1;minutes = 0;}

              if (seconds === 60) {minutes += 1;seconds = 0;}

              return '{0}h {1}m {2}s'.format(hours, minutes, seconds);
          }

          return input;
      };
  });